import React from 'react';
import { Box } from '@landr/maestro';
import { css } from '@landr/styled-system/css';
import getFilterParamsToType from 'apollo/userRecentSearch/helpers/getFilterParamsToType';
import { useApiFiltersContext } from 'contexts/ApiFiltersContext/ApiFiltersContext';
import { FiltersParams } from 'types/params';
import { RoutePaths } from 'types/enums';
import { usePrerenderComponentReady } from 'hooks/usePrerenderComponentReady/usePrerenderComponentReady';
import { FilterList } from './components/FilterList';
import { FilterSkeleton } from './components/FilterSkeleton';

const useListFilters = ({ filterParams }: { filterParams: FiltersParams }) => {
    const filterType = getFilterParamsToType(filterParams)?.toLowerCase();
    const { apiFilters } = useApiFiltersContext();

    const isSupportedFilterType =
        filterType === 'instruments' ||
        filterType === 'genres' ||
        filterType === 'sfxs';

    const filters = isSupportedFilterType && apiFilters[filterType];

    const showSkeleton = !filters || filters.length === 0;

    return { showSkeleton, filters };
};

export const ListFilters = ({
    filterParams,
    path,
}: {
    filterParams: FiltersParams;
    path: RoutePaths;
}) => {
    const { showSkeleton, filters } = useListFilters({ filterParams });

    usePrerenderComponentReady({
        hasDoneRendering: !!filters,
        componentName: 'ListFilters',
    });

    return (
        <Box
            className={css({
                columnCount: {
                    xl: 6,
                    lg: 5,
                    ml: 4,
                    md: 3,
                    ms: 2,
                    sm: 1,
                },
            })}
        >
            {showSkeleton && <FilterSkeleton />}
            {!showSkeleton && !!filters && (
                <FilterList path={path} filters={filters} />
            )}
        </Box>
    );
};
